import type { NextPage } from 'next'

import { NotFound } from '@/components/NotFound'

const NotFoundPage: NextPage = () => {
  return <NotFound />
}

export default NotFoundPage
